// extracted by mini-css-extract-plugin
export default {"gallery":"CustomIconPicker_gallery__k5C-2","customIcon":"CustomIconPicker_customIcon__kC-5a"};